var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDottedArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "14 20 22 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    d: "M17.99 5.528l.683.79.677-.79 2.917-3.304.034-.035c.032-.03.04-.038.074-.064.116-.086.252-.125.396-.125.04.003.052.002.092.01.376.074.655.555.532.991-.023.084-.06.163-.106.233-.025.037-.033.045-.06.08L19.15 7.93c-.03.032-.037.04-.07.069-.233.2-.583.205-.821 0-.033-.028-.04-.037-.07-.07l-4.077-4.616c-.028-.034-.036-.042-.062-.079-.24-.359-.13-.955.25-1.16.223-.12.505-.088.703.082.033.028.04.037.07.068l2.917 3.304z",
    transform: "translate(-20 -57) translate(20 57) translate(14 20) matrix(0 1 1 0 13.599 -13.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    d: "M3.959 4.074l-.001.001h-2v2h2v-2h4-2v2h2v-2h4-2v2h2v-2h4-2v2h2v-2h1.999v2H1c-.552 0-1-.447-1-1 0-.552.448-1 1-1h2.958z",
    transform: "translate(-20 -57) translate(20 57) translate(14 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedArrowRight);
export default __webpack_public_path__ + "static/media/dotted-arrow-right.cf85269504c2e595c8cc43b92474af80.svg";
export { ForwardRef as ReactComponent };